// extracted by mini-css-extract-plugin
export default {"container":"styles_container__r1SJu","header":"styles_header__7WM+t","content":"styles_content__FbzOD"};